package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.model.Tag
import com.example.readingnotes.domain.repository.TagRepository

class LoadPostTagsUseCase(
    private val tagRepository: TagRepository,
) {
    suspend operator fun invoke(postId: Int): Result<List<Tag>> = tagRepository.getTagsForPost(postId)
}
